import { CoordsObjectType, MarkersData } from "@/common/types";
import {
  AdvancedMarker,
  InfoWindow,
  useAdvancedMarkerRef,
} from "@vis.gl/react-google-maps";
import { useCallback, useState } from "react";
import CustomTypography from "../Typography/CustomTypography";

const networkStatus = {
  On_net: "On Net",
  Off_net: "Off Net",
  Near_net: "Near Net",
};
const networkStatusColors = {
  On_net: "green",
  Off_net: "error",
  Near_net: "yellow",
};

function Near50Pin() {
  return <img src="/images/blueMarker.svg" alt="near 300 marker icon" />;
}
function Near300Pin() {
  return <img src="/images/yellowMarker.svg" alt="near 300 marker icon" />;
}
interface NearByMarkersProps {
  position: CoordsObjectType;
  markerData: MarkersData;
  source: "50" | "300";
}
export default function NearByMarkers({
  position,
  markerData,
  source,
}: NearByMarkersProps) {
  if (source === "50") {
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
    const handleMarkerClick = useCallback(
      () => setShowInfoModal((isShown) => !isShown),
      []
    );
    const handleClose = useCallback(() => setShowInfoModal(false), []);
    return (
      <AdvancedMarker
        position={position}
        ref={markerRef}
        onClick={handleMarkerClick}
      >
        <Near50Pin />
        {showInfoModal && (
          <InfoWindow
            anchor={marker}
            headerDisabled
            zIndex={40}
            onClose={handleClose}
            className="h-[56px]"
          >
            <h2 className="font-kanit text-base font-medium capitalize">
              {markerData.fullAddress}
            </h2>
            <div className="flex items-center justify-center gap-4 mt-2">
              {markerData.providers.map((el: any) => (
                <CustomTypography
                  as="p"
                  size={'15px'}
                  weight={'semibold'}
                  color={networkStatusColors[el.networkStatus as  keyof typeof networkStatusColors] as 'error'|'yellow'|'green'}
                >
                  {networkStatus[el.networkStatus  as  keyof typeof networkStatus]}: {el.count}
                </CustomTypography>
              ))}
            </div>
          </InfoWindow>
        )}
      </AdvancedMarker>
    );
  }
  if (source === "300") {
    const [markerRef, marker] = useAdvancedMarkerRef();
    const [showInfoModal, setShowInfoModal] = useState<boolean>(false);
    const handleMarkerClick = useCallback(
      () => setShowInfoModal((isShown) => !isShown),
      []
    );
    const handleClose = useCallback(() => setShowInfoModal(false), []);
    return (
      <AdvancedMarker
        ref={markerRef}
        position={position}
        onClick={handleMarkerClick}
      >
        <Near300Pin />
        {showInfoModal && (
          <InfoWindow
            anchor={marker}
            headerDisabled
            zIndex={40}
            onClose={handleClose}
            className="h-[56px]"
          >
            <h2 className="font-kanit text-base font-medium capitalize">
              {markerData.fullAddress}
            </h2>
            <div className="flex items-center justify-center gap-2 mt-1">
              {markerData.providers.map((el: any) => (
                <CustomTypography
                  as="p"
                  size={'15px'}
                  className="pl-4"
                  weight={'semibold'}
                  color={networkStatusColors[el.networkStatus as  keyof typeof networkStatusColors] as 'error'|'yellow'|'green'}
                >
                  {networkStatus[el.networkStatus  as  keyof typeof networkStatus]}:{el.count}
                </CustomTypography>
              ))}
            </div>
          </InfoWindow>
        )}
      </AdvancedMarker>
    );
  }
}
